"use strict";
import { useContext, useEffect } from "react";
import { ShellContext } from "../context";
export const BlockLoading = () => {
  const { incrementLoadingCount, decrementLoadingCount } = useContext(ShellContext);
  useEffect(() => {
    incrementLoadingCount();
    return () => {
      decrementLoadingCount();
    };
  }, [incrementLoadingCount, decrementLoadingCount]);
  return null;
};
